/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Scan: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M113.777664 312.889344v-142.22336c0-31.418368 25.469952-56.88832 56.889344-56.88832h142.222336c15.70816 0 28.443648 12.735488 28.443648 28.444672s-12.734464 28.444672-28.443648 28.444672h-142.22336v142.222336c0 15.70816-12.734464 28.443648-28.443648 28.443648-15.709184 0-28.444672-12.734464-28.444672-28.443648z m56.889344 398.221312v142.22336h142.222336c15.70816 0 28.443648 12.734464 28.443648 28.443648 0 15.709184-12.734464 28.444672-28.443648 28.444672h-142.22336c-31.418368 0-56.88832-25.469952-56.88832-56.889344V711.110656c0-15.70816 12.735488-28.443648 28.444672-28.443648s28.444672 12.734464 28.444672 28.443648z m682.665984-398.221312v-142.22336H711.110656c-15.70816 0-28.443648-12.734464-28.443648-28.443648 0-15.709184 12.734464-28.444672 28.443648-28.444672h142.22336c31.418368 0 56.88832 25.469952 56.88832 56.889344v142.222336c0 15.70816-12.735488 28.443648-28.444672 28.443648s-28.444672-12.734464-28.444672-28.443648z m56.889344 398.221312v142.22336c0 31.418368-25.469952 56.88832-56.889344 56.88832H711.110656c-15.70816 0-28.443648-12.735488-28.443648-28.444672s12.734464-28.444672 28.443648-28.444672h142.22336V711.110656c0-15.70816 12.734464-28.443648 28.443648-28.443648 15.709184 0 28.444672 12.734464 28.444672 28.443648zM142.222336 483.555328H881.77664c15.709184 0 28.444672 12.735488 28.444672 28.444672s-12.735488 28.444672-28.444672 28.444672H142.22336c-15.709184 0-28.444672-12.735488-28.444672-28.444672s12.735488-28.444672 28.444672-28.444672z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Scan.defaultProps = {
  size: 18,
};

Scan = React.memo ? React.memo(Scan) : Scan;

export default Scan;
